module.exports = __webpack_public_path__ + "img/image 12.c0ad475b.png";